import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigSettings } from '@arc/arc-shared-frontend';
import {
  CreateHostedPaymentsSessionRequest,
  CreateHostedPaymentsSessionResponse,
  CreateStaticLinkSessionRequest,
  CreateStaticLinkSessionResponse,
  GetSessionFromPaymentLinkV1Response,
  IssuePlatformJwtRequest,
  IssuePlatformJwtResponse,
  VerifyUserRequest,
  VerifyUserResponse,
} from '../models';

/* istanbul ignore next */
@Injectable({
  providedIn: 'root',
})
export class PaymentLinkService {
  baseUrl: string;

  constructor(
    private httpClient: HttpClient,
    private appConfig: AppConfigSettings,
  ) {
    this.baseUrl = this.appConfig.getconfig('paymentLinkServiceUrl');
  }

  getSessionFromPaymentLink(
    paymentLinkToken: string,
  ): Observable<GetSessionFromPaymentLinkV1Response> {
    const getSessionUrl = `${this.baseUrl}/v1/paymentlinks/${paymentLinkToken}/session`;

    return this.httpClient.get<GetSessionFromPaymentLinkV1Response>(
      getSessionUrl,
    );
  }

  createHostedPaymentSession(
    supplierName: string,
    createSessionRequest: CreateHostedPaymentsSessionRequest,
  ): Observable<CreateHostedPaymentsSessionResponse> {
    const createSessionUrl = `${this.baseUrl}/v1/tenants/${supplierName}/session/hostedpaymentspage`;

    return this.httpClient.post<CreateHostedPaymentsSessionResponse>(
      createSessionUrl,
      createSessionRequest,
    );
  }

  createStaticLinkSession(
    supplierName: string,
    templateName: string,
    request: CreateStaticLinkSessionRequest,
  ): Observable<CreateStaticLinkSessionResponse> {
    const url = `${
      this.baseUrl
    }/v1/supplier/${supplierName}/template/${encodeURIComponent(
      templateName,
    )}/session`;

    return this.httpClient.post<CreateStaticLinkSessionResponse>(url, request);
  }

  validateToken(token: string): Observable<void> {
    const url = `${this.baseUrl}/v1/token/${token}/validate`;
    return this.httpClient.post<void>(url, null);
  }

  verifyUser(
    tenantId: string,
    request: VerifyUserRequest,
  ): Observable<VerifyUserResponse> {
    const url = `${this.baseUrl}/v1/tenants/${tenantId}/user/verify`;
    return this.httpClient.post<VerifyUserResponse>(url, request);
  }

  cancelVerification(tenantId: string, sessionId: string): Observable<void> {
    const url = `${this.baseUrl}/v1/tenants/${tenantId}/user/verify/session/${sessionId}`;
    return this.httpClient.delete<void>(url);
  }

  issuePlatformJwt(
    tenantId: string,
    request: IssuePlatformJwtRequest,
  ): Observable<IssuePlatformJwtResponse> {
    const url = `${this.baseUrl}/v1/tenants/${tenantId}/auth/issuePlatformJwt`;
    return this.httpClient.post<IssuePlatformJwtResponse>(url, request);
  }
}
